export default __webpack_public_path__ + "static/media/rmz.f6d5eb90.jfif";